// Headline numbers shown on the home page. Update when content grows (18 modules, 54 general + 153 exam-prep + 70 module quiz questions, 12 scenarios, 15 lab lessons, 16 guides).
export const SITE_STATS = { modules: 18, questions: 282, scenarios: 12, labLessons: 15, guides: 16 };
